module.exports = __webpack_public_path__ + "img/logo-chc-colour.5ad8e08e.png";